/**
 * Pure stake helpers for League Squares (chips on the grid = stake; no flat entrance fee).
 */

type SquaresSelection = { run?: string; chips?: number; odds?: string | number };

/** Sum of chip amounts on the grid selections. */
export function sumSquaresSelectionChips(
    selections: Record<string, SquaresSelection> | null | undefined,
): number {
    if (!selections || typeof selections !== "object") return 0;
    let total = 0;
    for (const sel of Object.values(selections)) {
        total += Math.max(0, Math.floor(Number(sel?.chips) || 0));
    }
    return total;
}

/**
 * League Squares stake = chips placed on the grid (totalChips preferred, else Σ selection chips).
 */
export function resolveLeagueSquaresStake(input: {
    stake?: number;
    totalChips?: number;
    selections?: Record<string, SquaresSelection> | null;
}): number {
    const fromTotal = Math.floor(Number(input.totalChips));
    if (Number.isFinite(fromTotal) && fromTotal > 0) return fromTotal;
    const fromSelections = sumSquaresSelectionChips(input.selections);
    if (fromSelections > 0) return fromSelections;
    const fromStake = Math.floor(Number(input.stake));
    return Number.isFinite(fromStake) && fromStake > 0 ? fromStake : 0;
}

/** Chip floor stamped on an open Squares play at seat top-up (0 = may still reduce). */
export function leagueSquaresPlayStakeFloor(
    play:
        | {
              stake_floor?: unknown;
              stakeFloor?: unknown;
              marketDetails?: { stakeFloor?: unknown } | null;
          }
        | null
        | undefined,
): number {
    if (play == null) return 0;
    const fromPlay = Math.max(
        0,
        Math.floor(Number(play.stake_floor ?? play.stakeFloor) || 0),
    );
    const fromMd = Math.max(0, Math.floor(Number(play.marketDetails?.stakeFloor) || 0));
    const floor = Math.max(fromPlay, fromMd);
    return Number.isFinite(floor) ? floor : 0;
}
